if (!customElements.get('lp-pack-picker')) {
  customElements.define('lp-pack-picker', class extends HTMLElement {
    connectedCallback() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => this.initialize());
    }

    initialize() {
      if (!this.isConnected || this.controller) return;
      this.form = this.querySelector('.pp-form');
      if (!this.form) return;
      this.cards = Array.from(this.querySelectorAll('.pp-card'));
      this.button = this.form.querySelector('.pp-button');
      this.error = this.form.querySelector('.pp-error');
      this.idInput = this.form.querySelector('[name="id"]');
      this.quantityInput = this.form.querySelector('[name="quantity"]');
      this.buttonLabel = this.button.textContent.trim();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.form.addEventListener('change', () => {
        this.error.hidden = true;
        this.update();
      }, options);
      this.form.addEventListener('submit', event => this.add(event), options);
      this.update();
    }

    selectedCard() {
      return this.cards.find(card => {
        const radio = card.querySelector('input[name="pack"]');
        return radio.checked && !radio.disabled;
      });
    }

    update() {
      const selected = this.selectedCard();
      this.cards.forEach(card => {
        card.classList.toggle('is-selected', card === selected);
      });
      this.idInput.value = selected ? selected.dataset.variantId : '';
      this.quantityInput.value = selected ? selected.dataset.cartQuantity : '1';
      this.button.disabled = this.busy || !selected;
    }

    async add(event) {
      event.preventDefault();
      if (this.busy) return;
      this.error.hidden = true;
      const card = this.selectedCard();
      const id = card ? card.dataset.variantId : '';
      const quantity = card ? Number(card.dataset.cartQuantity) : 0;
      if (!/^\d+$/.test(id) || !Number.isSafeInteger(quantity) || quantity < 1) {
        this.error.textContent = 'Please select an available pack.';
        this.error.hidden = false;
        return;
      }

      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.button.textContent = 'Adding…';
      this.form.querySelector('fieldset').disabled = true;

      try {
        const response = await fetch(this.form.dataset.addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({ items: [{ id, quantity }] })
        });
        let result;
        try {
          result = await response.json();
        } catch (error) {
          throw new Error('Unable to confirm the cart. Check your cart before trying again.');
        }
        if (!response.ok || result.status >= 400) {
          throw new Error(
            result.description || result.message ||
            'Unable to add this pack. Please check availability and try again.'
          );
        }
        window.location.assign(this.form.dataset.cartUrl);
      } catch (error) {
        this.error.textContent = error.message || 'Unable to add items. Please try again.';
        this.error.hidden = false;
        this.busy = false;
        this.button.textContent = this.buttonLabel;
        this.button.removeAttribute('aria-busy');
        this.form.querySelector('fieldset').disabled = false;
        this.update();
      }
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      if (this.controller) this.controller.abort();
      this.controller = null;
    }
  });
}
